import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ContentContainer, MainContent, CenteredCard, DiskButton, DiskTypography, ResetButton, ResetIcon, LampSVG, LampSVGReset, LampSVGPumps, RefreshIcon } from '../Styles/RemoteAccess';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Typography, Button } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import Sidebar from '../Parts/Sidebar';
import Header from '../Parts/Header';
import Footer from '../Parts/Footer';
import { useLogoTitle } from '../classes/LogoTitleContext';
import { Tabs, Tab, Card } from '@mui/material';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import Papa from 'papaparse';
import axios from 'axios';
import refreshIcon from '../Images/refresh-icon-remote-access.svg';

const RemoteAccess2DP2VP = ({ onLogout, loggedInUser, clientId }) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const { logoUrl, projectTitle } = useLogoTitle();
    const [filteredData, setFilteredData] = useState([]);
    const [vacuumLampPump1State, setVacuumLampPump1State] = useState(null);
    const [vacuumLampPump2State, setVacuumLampPump2State] = useState(null);
    const [dischargeLampPump1State, setDischargeLampPump1State] = useState(null);
    const [dischargeLampPump2State, setDischargeLampPump2State] = useState(null);
    const [vacuumPump1State, setVacuumPump1State] = useState(null);
    const [vacuumPump2State, setVacuumPump2State] = useState(null);
    const [dischargePump1State, setDischargePump1State] = useState(null);
    const [dischargePump2State, setDischargePump2State] = useState(null);
    const [resetLampState, setResetLampState] = useState('white');
    const [shutOffValveStates, setShutOffValveStates] = useState({
        1: 'white',
        2: 'white',
        3: 'white',
        4: 'white',
        5: 'white',
        6: 'white',
    });

    const [activeTab, setActiveTab] = useState(0);
    const [error, setError] = useState(null);
    const [fetchDataFlag, setFetchDataFlag] = useState(false);
    const [pumpStatusData, setPumpStatusData] = useState({});

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleRefresh = () => {
        if (activeTab === 0) {
            alert("Reset tab with data is refreshed!");
        } else if (activeTab === 1) {
            alert("Shut Off Valve tab with data is refreshed!");
        } else if (activeTab === 2) {
            alert("Pump Cycles tab with data is refreshed!");

            setFilteredData([]); // Clear filtered data
            setPumpStatusData([]);
            setFetchDataFlag(prev => !prev); // Toggle flag to trigger useEffect
        }
    };

    useEffect(() => {
        const fetchPumpModeStatus = async () => {
            try {
                const authHeaders = getAuthHeaders(); // Ensure you have your auth headers
                const response = await axios.post(
                    `${API_ENDPOINTS.GetRemotePumpModeStatus}`, // Single API call
                    {},
                    { headers: { ...authHeaders } }
                );

                //console.log('Pump Mode Status API Response:', response.data);

                const { data } = response.data;
                if (data && Array.isArray(data)) {
                    // Store the entire fetched data
                    setFilteredData(data);

                    // Process data into a structured object
                    const processedData = data.reduce((acc, item) => {
                        acc[item.TagName] = item.Value;
                        return acc;
                    }, {});

                    //console.log('Processed Pump Status Data:', processedData);

                    // Update pump mode status
                    setPumpStatusData(processedData);

                    // Update lamp states based on VP1, VP2, DP1, DP2
                    setVacuumLampPump1State(processedData.VP1 === '1' ? 'green' : 'red');
                    setVacuumLampPump2State(processedData.VP2 === '1' ? 'green' : 'red');
                    setDischargeLampPump1State(processedData.DP1 === '1' ? 'green' : 'red');
                    setDischargeLampPump2State(processedData.DP2 === '1' ? 'green' : 'red');
                } else {
                    console.error('[ERROR] Invalid data format received from backend.');
                }
            } catch (error) {
                console.error('Error fetching pump status:', error.response ? error.response.data : error.message);
            }
        };

        // Fetch data every 5 seconds
        const intervalId = setInterval(fetchPumpModeStatus, 5000);

        // Cleanup function to clear interval on unmount
        return () => clearInterval(intervalId);
    }, [fetchDataFlag]);

    const handlePumpStateChange = (pumpType, pumpNumber, state) => {
        // Log the incoming parameters to check their values
        //console.log('Pump Type:', pumpType);
        //console.log('Pump Number:', pumpNumber);
        //console.log('State:', state);

        let commandID = "";
        const commandInput = 1; // Always 1 as per your requirement

        // Determine the CommandID based on pump type, number, and state
        if (pumpType === 'vacuum') {
            if (pumpNumber === 1) {
                if (state === 'AUTO') commandID = "vlinkAutoVP1";
                else if (state === 'ON') commandID = "vlinkOnVP1";
                else if (state === 'OFF') commandID = "vlinkOffVP1";
            } else if (pumpNumber === 2) {
                if (state === 'AUTO') commandID = "vlinkAutoVP2";
                else if (state === 'ON') commandID = "vlinkOnVP2";
                else if (state === 'OFF') commandID = "vlinkOffVP2";
            }
        } else if (pumpType === 'discharge') {
            if (pumpNumber === 1) {
                if (state === 'AUTO') commandID = "vlinkAutoDP1";
                else if (state === 'ON') commandID = "vlinkOnDP1";
                else if (state === 'OFF') commandID = "vlinkOffDP1";
            } else if (pumpNumber === 2) {
                if (state === 'AUTO') commandID = "vlinkAutoDP2";
                else if (state === 'ON') commandID = "vlinkOnDP2";
                else if (state === 'OFF') commandID = "vlinkOffDP2";
            }
        }

        // Ask for confirmation before sending the command
        const confirmMessage = `Are you sure you want to set ${pumpType} pump ${pumpNumber} to ${state}?`;
        if (window.confirm(confirmMessage)) {
            // Log the data for debugging
            //console.log("Sending Command:", { commandID, commandInput, pumpType, pumpNumber, state });

            // Simulate sending the data to the backend and assume success
            sendPumpUpdateCommand({ commandID, commandInput, pumpType, pumpNumber, state });

        }
    };

    const sendPumpUpdateCommand = async ({ commandID, commandInput, pumpType, pumpNumber, state }) => {
        try {
            // Ensure you have your auth headers
            const authHeaders = getAuthHeaders();

            // Log the data being sent to the backend for debugging
            //console.log('Sending Command:', { commandID, commandInput, pumpType, pumpNumber, state });

            // Construct the URL or the request body with necessary parameters
            const url = `${API_ENDPOINTS.RemoteAccessPumpUpdate}`;

            const response = await axios.post(
                url,
                {
                    clientId: loggedInUser.clientId,
                    CommandID: commandID,
                    CommandInput: commandInput,
                    pumpType: pumpType,
                    pumpNumber: pumpNumber,
                    state: state
                },
                { headers: { ...authHeaders } }
            );

            // Log the backend response
            //console.log("Backend Response:", response.data);

            // Show success alert
            alert("Command sent successfully.");
        } catch (error) {
            // Handle and log any errors
            console.error("Error sending command:", error);

            // Show error alert
            alert("Command not sent, please contact support team.");
        }
    };

    const handleShutOffValveStateChange = async (valveNumber, state) => {
        const confirmReset = window.confirm("Are you sure you want to perform the ShutOffValve?");
        if (!confirmReset) {
            //console.log('ShutOffValve action was canceled.');
            return; // Exit the function if the user cancels
        }

        // Generate CommandID and CommandInput based on the valve number and state
        let CommandID = '';
        let CommandInput = '';
        let CommandAck = '';

        if (state === 'ON') {
            CommandID = `OpenElecValve${valveNumber}`;
            CommandInput = 1;
            CommandAck = `AckOpenCloseValve${valveNumber}`;
        } else if (state === 'OFF') {
            CommandID = `CloseElecValve${valveNumber}`;
            CommandInput = 1;
            CommandAck = `AckOpenCloseValve${valveNumber}`;
        }

        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.RemoteAcess}`, { CommandID, CommandInput, CommandAck }, { headers: { ...authHeaders } });

            const data = response.data;
            //console.log('Full Response from backend:', data);

            if (data?.data?.length > 0) {
                const filteredData = data.data.map(({ TagName, Value }) => ({ TagName, Value }));
                //console.log('Filtered Data (TagName and Value):', filteredData);

                filteredData.forEach(({ TagName, Value }) => {
                    const match = TagName.match(/(\d+)/);
                    const matchedValveNumber = match ? parseInt(match[1], 10) : null;

                    if (matchedValveNumber) {
                        const isAckOpenCloseValve = TagName.includes('AckOpenCloseValve');
                        const valueString = String(Value).trim();

                        // Update the state based on valve action (0 or 1)
                        setShutOffValveStates((prevStates) => {
                            const newState = {
                                ...prevStates,
                                [matchedValveNumber]: isAckOpenCloseValve
                                    ? valueString === '0'
                                        ? 'green'
                                        : 'red'
                                    : prevStates[matchedValveNumber],
                            };
                            //console.log('Updated state:', newState);
                            return newState;
                        });
                    }
                });

                // Display success message
                alert("Command sent successfully.");
            } else {
                console.warn('No data received or matching rows found.');
                // Display failure message
                alert("Command not sent, please contact support team.");
            }
        } catch (error) {
            console.error('Error:', error);
            // Display failure message if an error occurs
            alert("Command not sent, please contact support team.");
        }
    };

    const handleResetClick = async (CommandID, CommandInput, CommandAck) => {
        //console.log('CommandID:', CommandID);
        //console.log('CommandInput:', CommandInput);
        //console.log('CommandAck:', CommandAck);

        const confirmReset = window.confirm("Are you sure you want to perform the reset?");
        if (!confirmReset) {
            //console.log('Reset action was canceled.');
            return; // Exit the function if the user cancels
        }

        try {
            // Send data to the backend via POST request
            const authHeaders = getAuthHeaders();
            const response = await fetch(`${API_ENDPOINTS.RemoteAcess}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...authHeaders,
                },
                body: JSON.stringify({ CommandID, CommandInput, CommandAck }),
            });

            // Parse response from the backend
            const data = await response.json();
            //console.log('Response from backend:', data);

            // Check for the response status and handle accordingly
            if (data?.status === 'success' && data?.data?.length > 0) {
                const filteredData = data.data.map(({ TagName, Value }) => ({ TagName, Value }));
                //console.log('Filtered Data (TagName and Value):', filteredData);

                // Assuming vlinkResetResult is in the response, update the lamp color
                filteredData.forEach(({ TagName, Value }) => {
                    if (TagName === 'vLinkResetResult') {
                        // Update lamp state based on the value
                        if (Value === '1') {
                            setResetLampState('green'); // Green lamp for Value = 0
                        } else if (Value === '0') {
                            setResetLampState('red'); // Red lamp for Value = 1
                        }
                    }
                });

                // Display success message
                alert("Command sent successfully.");
            } else {
                console.warn('No data received or matching rows found.');
                // Display failure message
                alert("Command not sent, please contact support team.");
            }
        } catch (error) {
            console.error('Error:', error);
            // Display failure message if an error occurs
            alert("Command not sent, please contact support team.");
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ backgroundColor: '#EBEFF3', height: '100vh' }}>
                <Sidebar loggedInUser={loggedInUser} />
                <Header logoUrl={logoUrl} loggedInUser={loggedInUser} onLogout={onLogout} />
                <ContentContainer>
                    <MainContent>
                        {/* Centered Card */}
                        <CenteredCard>
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    marginTop: '10px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                {/* Left Box with Vacuum and Tank Levels */}
                                <div
                                    style={{
                                        display: 'flex',
                                        backgroundColor: '#f9f9f9',
                                        padding: '6px 6px',
                                        borderRadius: '16px',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    {/* Vacuum Level */}
                                    <div
                                        style={{
                                            background: 'linear-gradient(135deg,rgb(189, 231, 250),rgb(147, 227, 253))',
                                            color: 'black',
                                            padding: '6px 8px',
                                            borderRadius: '12px',
                                            marginRight: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                        }}
                                    >
                                        Vacuum Level | {pumpStatusData['Vaccum_Level'] || '0'}
                                    </div>

                                    {/* Tank Level */}
                                    <div
                                        style={{
                                            background: 'linear-gradient(135deg,rgb(193, 247, 193),rgb(170, 241, 170))',
                                            color: 'black',
                                            padding: '6px 8px',
                                            borderRadius: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                        }}
                                    >
                                        Tank Level | {pumpStatusData['Tank_Level'] || '0'}
                                    </div>
                                </div>

                                {/* Refresh Icon */}
                                <RefreshIcon
                                    title="Refresh"
                                    src={refreshIcon}
                                    alt="Refresh"
                                    onClick={handleRefresh}
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s ease-in-out',
                                    }}
                                />
                            </div>
                            <div style={{ padding: '10px' }}>
                                {/* Tabs */}
                                <div style={{ width: '100%' }}>
                                    <Tabs
                                        value={activeTab}
                                        onChange={handleTabChange}
                                        indicatorColor="secondary"
                                        textColor="primary"
                                        centered
                                        style={{
                                            backgroundColor: theme.palette.background.paper,
                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        <Tab label={<span style={{ color: "#D32F2F", fontWeight: "bold", fontSize: "15px", textTransform: "uppercase" }}>Reset</span>} />
                                        <Tab label={<span style={{ color: "#1976D2", fontWeight: "bold", fontSize: "15px", textTransform: "uppercase" }}>Shut Off Valve</span>} />
                                        <Tab label={<span style={{ color: "#388E3C", fontWeight: "bold", fontSize: "15px", textTransform: "uppercase" }}>Pump Cycles</span>} />


                                    </Tabs>
                                </div>
                            </div>
                            {activeTab === 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        height: '100%',
                                        padding: '10px',
                                    }}
                                >
                                    <LampSVGReset state={resetLampState} />
                                    <ResetButton
                                        variant="outlined"
                                        onClick={() => handleResetClick('vlinkReset', 1, 'vLinkResetResult')}
                                        style={{ marginTop: 'auto' }}
                                    >
                                        <ResetIcon />
                                        Reset
                                    </ResetButton>
                                </div>
                            )}
                            {activeTab === 1 && (
                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(3, 1fr)',
                                        gap: '20px',
                                        padding: '20px',
                                    }}
                                >
                                    {Array.from({ length: 6 }, (_, i) => i + 1).map((valveNumber) => (
                                        <div
                                            key={valveNumber}
                                            style={{
                                                textAlign: 'center',
                                                borderRadius: '15px',
                                                padding: '20px',
                                                backdropFilter: 'blur(12px)',
                                                background: 'rgba(255, 255, 255, 0.1)',
                                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                                                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-5px)';
                                                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.3)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2)';
                                            }}
                                        >
                                            <h6
                                                style={{
                                                    marginBottom: '10px',
                                                    fontSize: '24px',
                                                    color: '#ffffff',
                                                    fontWeight: 'bold',
                                                    letterSpacing: '1px',
                                                    textTransform: 'uppercase',
                                                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Shut Off Valve {valveNumber}
                                            </h6>

                                            <LampSVG state={shutOffValveStates[valveNumber]} />
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-around',
                                                    marginTop: '20px',
                                                }}
                                            >
                                                <button
                                                    style={{
                                                        padding: '12px 24px',
                                                        background: 'linear-gradient(145deg, #4CAF50, #81C784)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '8px',
                                                        fontSize: '14px',
                                                        cursor: 'pointer',
                                                        transition: 'background 0.3s ease',
                                                    }}
                                                    onMouseEnter={(e) =>
                                                        (e.target.style.background = 'linear-gradient(135deg, #43a047, #7cb342)')
                                                    }
                                                    onMouseLeave={(e) =>
                                                        (e.target.style.background = 'linear-gradient(135deg, #4caf50, #8bc34a)')
                                                    }
                                                    onClick={() => handleShutOffValveStateChange(valveNumber, 'ON')}
                                                >
                                                    ON
                                                </button>
                                                <button
                                                    style={{
                                                        padding: '12px 24px',
                                                        background: 'linear-gradient(145deg, #D32F2F, #C62828)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '8px',
                                                        fontSize: '14px',
                                                        cursor: 'pointer',
                                                        transition: 'background 0.3s ease',
                                                    }}
                                                    onMouseEnter={(e) =>
                                                        (e.target.style.background = 'linear-gradient(135deg, #c62828, #e57373)')
                                                    }
                                                    onMouseLeave={(e) =>
                                                        (e.target.style.background = 'linear-gradient(135deg, #e53935, #f44336)')
                                                    }
                                                    onClick={() => handleShutOffValveStateChange(valveNumber, 'OFF')}
                                                >
                                                    OFF
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {/* Pump Grid */}
                            {activeTab === 2 && (
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                    {/* Vacuum Pump 1 */}
                                    <div>
                                        <DiskTypography variant="h6" align="center">
                                            Vacuum Pump 1
                                            {vacuumLampPump1State && (
                                                <LampSVGPumps
                                                    state={vacuumLampPump1State}
                                                />
                                            )}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                                                <DiskButton
                                                    state={pumpStatusData.vlinkIsAutoVP1 === "1" ? 'ON' : 'OFF'}
                                                    vacuumPumpState={vacuumPump1State}
                                                    onClick={() => handlePumpStateChange('vacuum', 1, 'AUTO')}
                                                    style={{
                                                        background: pumpStatusData.vlinkIsAutoVP1 === "1"
                                                            ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                            : ''
                                                    }}
                                                >
                                                    AUTO
                                                </DiskButton>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        border: '1px solid rgba(255, 239, 93, 0.6)',
                                                        padding: '8px 12px',
                                                        borderRadius: '15px',
                                                        background: 'rgba(0, 0, 0, 0.2)',
                                                        boxShadow: 'inset 0px 4px 6px rgba(0, 0, 0, 0.5), 0px 4px 10px rgba(76, 175, 80, 0.3)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                >
                                                    <div style={{
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        fontSize: '1rem',
                                                        fontFamily: 'Akkurat, sans-serif',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '1px',
                                                        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
                                                    }}>
                                                        FORCE
                                                    </div>

                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOnVP1 === "1" ? 'ON' : 'OFF'}
                                                            vacuumPumpState={vacuumPump1State}
                                                            onClick={() => handlePumpStateChange('vacuum', 1, 'ON')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOnVP1 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}

                                                        >
                                                            ON
                                                        </DiskButton>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOffVP1 === "1" ? 'ON' : 'OFF'}
                                                            vacuumPumpState={vacuumPump1State}
                                                            onClick={() => handlePumpStateChange('vacuum', 1, 'OFF')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOffVP1 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}

                                                        >
                                                            OFF
                                                        </DiskButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </DiskTypography>
                                    </div>

                                    {/* Vacuum Pump 2 */}
                                    <div>
                                        <DiskTypography variant="h6" align="center">
                                            Vacuum Pump 2
                                            {vacuumLampPump2State && (
                                                <LampSVGPumps
                                                    state={vacuumLampPump2State}
                                                />
                                            )}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                                                <DiskButton
                                                    state={pumpStatusData.vlinkIsAutoVP2 === "1" ? 'ON' : 'OFF'}
                                                    vacuumPumpState={vacuumPump2State}
                                                    onClick={() => handlePumpStateChange('vacuum', 2, 'AUTO')}
                                                    style={{
                                                        background: pumpStatusData.vlinkIsAutoVP2 === "1"
                                                            ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                            : ''
                                                    }}

                                                >
                                                    AUTO
                                                </DiskButton>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        border: '1px solid rgba(255, 239, 93, 0.6)',
                                                        padding: '8px 12px',
                                                        borderRadius: '15px',
                                                        background: 'rgba(0, 0, 0, 0.2)',
                                                        boxShadow: 'inset 0px 4px 6px rgba(0, 0, 0, 0.5), 0px 4px 10px rgba(76, 175, 80, 0.3)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                >
                                                    <div style={{
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        fontSize: '1rem',
                                                        fontFamily: 'Akkurat, sans-serif',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '1px',
                                                        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
                                                    }}>
                                                        FORCE
                                                    </div>

                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOnVP2 === "1" ? 'ON' : 'OFF'}
                                                            vacuumPumpState={vacuumPump2State}
                                                            onClick={() => handlePumpStateChange('vacuum', 2, 'ON')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOnVP2 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}

                                                        >
                                                            ON
                                                        </DiskButton>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOffVP2 === "1" ? 'ON' : 'OFF'}
                                                            vacuumPumpState={vacuumPump2State}
                                                            onClick={() => handlePumpStateChange('vacuum', 2, 'OFF')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOffVP2 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}

                                                        >
                                                            OFF
                                                        </DiskButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </DiskTypography>
                                    </div>

                                    {/* Discharge Pump 1 */}
                                    <div>
                                        <DiskTypography variant="h6" align="center">
                                            Discharge Pump 1
                                            {dischargeLampPump1State && (
                                                <LampSVGPumps
                                                    state={dischargeLampPump1State}
                                                />
                                            )}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                                                <DiskButton
                                                    state={pumpStatusData.vlinkIsAutoDP1 === "1" ? 'ON' : 'OFF'}
                                                    dischargePumpState={dischargePump1State}
                                                    onClick={() => handlePumpStateChange('discharge', 1, 'AUTO')}
                                                    style={{
                                                        background: pumpStatusData.vlinkIsAutoDP1 === "1"
                                                            ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                            : ''
                                                    }}

                                                >
                                                    AUTO
                                                </DiskButton>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        border: '1px solid rgba(255, 239, 93, 0.6)',
                                                        padding: '8px 12px',
                                                        borderRadius: '15px',
                                                        background: 'rgba(0, 0, 0, 0.2)',
                                                        boxShadow: 'inset 0px 4px 6px rgba(0, 0, 0, 0.5), 0px 4px 10px rgba(76, 175, 80, 0.3)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                >
                                                    <div style={{
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        fontSize: '1rem',
                                                        fontFamily: 'Akkurat, sans-serif',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '1px',
                                                        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
                                                    }}>
                                                        FORCE
                                                    </div>

                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOnDP1 === "1" ? 'ON' : 'OFF'}
                                                            dischargePumpState={dischargePump1State}
                                                            onClick={() => handlePumpStateChange('discharge', 1, 'ON')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOnDP1 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}

                                                        >
                                                            ON
                                                        </DiskButton>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOffDP1 === "1" ? 'ON' : 'OFF'}
                                                            dischargePumpState={dischargePump1State}
                                                            onClick={() => handlePumpStateChange('discharge', 1, 'OFF')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOffDP1 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}

                                                        >
                                                            OFF
                                                        </DiskButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </DiskTypography>
                                    </div>

                                    {/* Discharge Pump 2 */}
                                    <div>
                                        <DiskTypography variant="h6" align="center">
                                            Discharge Pump 2
                                            {dischargeLampPump2State && (
                                                <LampSVGPumps
                                                    state={dischargeLampPump2State}
                                                />
                                            )}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
                                                <DiskButton
                                                    state={pumpStatusData.vlinkIsAutoDP2 === "1" ? 'ON' : 'OFF'}
                                                    dischargePumpState={dischargePump2State}
                                                    onClick={() => handlePumpStateChange('discharge', 2, 'AUTO')}
                                                    style={{
                                                        background: pumpStatusData.vlinkIsAutoDP2 === "1"
                                                            ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                            : ''
                                                    }}

                                                >
                                                    AUTO
                                                </DiskButton>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        border: '1px solid rgba(255, 239, 93, 0.6)',
                                                        padding: '8px 12px',
                                                        borderRadius: '15px',
                                                        background: 'rgba(0, 0, 0, 0.2)',
                                                        boxShadow: 'inset 0px 4px 6px rgba(0, 0, 0, 0.5), 0px 4px 10px rgba(76, 175, 80, 0.3)',
                                                        transition: 'all 0.3s ease',
                                                    }}
                                                >
                                                    <div style={{
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        fontSize: '1rem',
                                                        fontFamily: 'Akkurat, sans-serif',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '1px',
                                                        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
                                                    }}>
                                                        FORCE
                                                    </div>

                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOnDP2 === "1" ? 'ON' : 'OFF'}
                                                            dischargePumpState={dischargePump2State}
                                                            onClick={() => handlePumpStateChange('discharge', 2, 'ON')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOnDP2 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}
                                                        >
                                                            ON
                                                        </DiskButton>
                                                        <DiskButton
                                                            state={pumpStatusData.vlinkIsOffDP2 === "1" ? 'ON' : 'OFF'}
                                                            dischargePumpState={dischargePump2State}
                                                            onClick={() => handlePumpStateChange('discharge', 2, 'OFF')}
                                                            style={{
                                                                background: pumpStatusData.vlinkIsOffDP2 === "1"
                                                                    ? 'linear-gradient(145deg, #4CAF50, #81C784)'
                                                                    : ''
                                                            }}
                                                        >
                                                            OFF
                                                        </DiskButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </DiskTypography>
                                    </div>
                                </div>
                            )}
                        </CenteredCard>
                    </MainContent>
                </ContentContainer>
                <Footer />
                <ToastContainer />
            </div>
        </LocalizationProvider>
    );
};

export default RemoteAccess2DP2VP;